"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thorgate = void 0;
var Card_1 = require("../Card");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Thorgate = (function (_super) {
    __extends(Thorgate, _super);
    function Thorgate() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.THORGATE,
            tags: [Tags_1.Tags.ENERGY],
            startingMegaCredits: 48,
            cardDiscount: { tag: Tags_1.Tags.ENERGY, amount: 3 },
            metadata: {
                cardNumber: 'R13',
                description: 'You start with 1 energy production and 48 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.production(function (pb) { return pb.energy(1); }).nbsp.megacredits(48);
                    b.corpBox('effect', function (ce) {
                        ce.effect('When playing a power card OR THE STANDARD PROJECT POWER PLANT, you pay 3 M€ less for it.', function (eb) {
                            eb.energy(1).played.asterix().startEffect.megacredits(-3);
                        });
                    });
                }),
            },
        }) || this;
    }
    Thorgate.prototype.getCardDiscount = function (_player, card) {
        if (card.tags.includes(Tags_1.Tags.ENERGY)) {
            return 3;
        }
        return 0;
    };
    Thorgate.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        return undefined;
    };
    return Thorgate;
}(Card_1.Card));
exports.Thorgate = Thorgate;
//# sourceMappingURL=Thorgate.js.map